import React,{useState,useEffect} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, DialogActions, DialogContent, IconButton, } from '@mui/material';
import closeButton from '../../Assets/popup-close.svg';
import Preview from './Slide_Preview';
// import ""



function SaveTemplate({heading, open, onClose, onSave,eventName,handleInputChange,savedName}) {
   
const [openPreview,setOpenPreview] = useState(false);
const [errorMsg, setErrorMsg] = useState('');
const [maxChars,setMaxChars] = useState(50);

const handleClose = () => onClose();
    const previewClick=()=>{
      setOpenPreview(!openPreview); 
    }
    const closePreview=()=>{
      setOpenPreview(false); 
    }


useEffect(()=>{
  setMaxChars(50 - savedName.length);
},[savedName]);


const handleSave = ()=>{
  if(savedName.trim() === '') {
    setErrorMsg("* Enter a callout name before saving...") 
  } else{
    onSave();
    handleClose();
  }
}
useEffect(()=>{
setErrorMsg('');
},[open]);


  return (
   <Dialog
   open = {open}
   onClose= {handleClose}
   slotProps={{
    backdrop: {
      style: { 
        backgroundColor: 'rgba(0, 0, 0, 0.1)' , 
      }, // Adjust the opacity here

    },
  }}
  style={{ zIndex: 5000 }} 
   maxWidth= "xs"
   fullWidth>
 <DialogTitle>
     <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 5px",
        
          }}
          >
            <p style={{fontSize:"20px", fontWeight:"600",color:"#121B45"}}>{heading}</p>
            <IconButton onClick={handleClose}>
            <img src={closeButton} alt="close-button" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        {
          heading === "Save Event" && (
            <div style={{display:'flex',flexDirection:'column',alignItems:'start',justifyContent:'center',gap:'10px',paddingLeft:'15px'}}>
      <p style={{fontSize:'17px',color:'#757ea5', fontWeight:"600"}}>Event Name</p>
            <p style={{fontSize:'16px',color:'#121B45'}}>{eventName}</p>
            <div style={{}}></div>
            </div>
          )
        }
       
          <div className="input-row">  
        <div className='input-item' >
         <label>
          <div style={{fontSize:"17px", fontWeight:"600",color:'#757ea5'}}>
            <p>{heading === "Save Workflow Template"? "Workflow Name" : heading === "Save Event"? "Callout name" : "Subflow Name"} (<span style={{fontSize:'15px',fontWeight:'bold',color: maxChars === 50 ? '#289e13' : '#ff0000'}}>{maxChars}</span> <span style={{fontSize:'15px'}}>chars</span>)</p>
            <p style={{color:'#ff0000'}}>{errorMsg}</p>
          </div>
          </label>
         <input style={{border:"1px solid #CFD4E9", fontSize:"16px", color:"#121B45", width:"100%"}} type="text" onChange={handleInputChange} value={savedName || ''} maxLength={50}></input>
         </div>
       
         </div>
      <div className='saveTemplate-button'>
      <Button variant = 'contained' style ={{backgroundColor: '#02ACF6', textTransform: 'none',}} onClick={() => { handleSave() }} className="dialog-save-button">
          Save
        </Button>
      {
          heading !== "Save Event" && (
            <Button variant='contained' style={{backgroundColor: '#121B4580', textTransform:'none',  marginLeft: '200px'}} onClick={previewClick}>Preview</Button>
          )}

        </div>
        <Preview openPre ={openPreview} closePre={previewClick} localView = {true}/>
        </DialogContent>
   </Dialog>
  )
  
}

export default SaveTemplate;